import React from 'react';

function ConceptInput({ concepts, onChange }) {
  const inputRef = React.useRef(null);

  const addConcept = (concept) => {
    if (concept.trim() && concepts.length < 6 && concept.length <= 40) {
      onChange([...concepts, concept.trim()]);
      return true;
    }
    return false;
  };

  const removeConcept = (index) => {
    onChange(concepts.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.target.value.trim()) {
      e.preventDefault();
      if (addConcept(e.target.value)) {
        e.target.value = '';
      }
    }
  };

  const handleAddClick = () => {
    if (inputRef.current && inputRef.current.value.trim()) {
      if (addConcept(inputRef.current.value)) {
        inputRef.current.value = '';
        inputRef.current.focus();
      }
    }
  };

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-4">
        {concepts.map((concept, index) => (
          <div
            key={index}
            className="inline-flex items-center gap-2 px-3 py-2 bg-blue-100 text-blue-800 rounded-full"
          >
            <span className="text-sm">{concept}</span>
            <button
              onClick={() => removeConcept(index)}
              className="text-blue-600 hover:text-blue-800 font-bold text-lg leading-none w-6 h-6 flex items-center justify-center rounded-full hover:bg-blue-200 transition-colors"
              aria-label={`Remove ${concept}`}
            >
              ×
            </button>
          </div>
        ))}
      </div>
      
      <div className="flex gap-2">
        <input
          ref={inputRef}
          type="text"
          placeholder="Add a concept (press Enter or click Add)"
          onKeyDown={handleKeyDown}
          disabled={concepts.length >= 6}
          className="flex-1 px-4 py-3 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
          style={{
            WebkitAppearance: 'none',
            WebkitTapHighlightColor: 'transparent',
            touchAction: 'manipulation',
            fontSize: '16px'
          }}
          autoComplete="off"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck="false"
        />
        <button
          onClick={handleAddClick}
          disabled={concepts.length >= 6}
          className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors min-h-[52px] touch-manipulation"
          style={{ touchAction: 'manipulation' }}
        >
          Add
        </button>
      </div>
      
      <p className="mt-2 text-sm text-gray-500">
        {concepts.length}/6 concepts {concepts.length >= 6 && '(maximum reached)'}
      </p>
    </div>
  );
}

export default ConceptInput;
